import { faHand, faHandWave } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskClaimActionPropsType = {
  isUnclaim: boolean;
  onClick: () => void;
};

export const TaskClaimAction: React.FC<TaskClaimActionPropsType> = ({
  isUnclaim,
  onClick,
}) => {
  const { t } = useTranslation('tasks');

  const label = isUnclaim ? t('ACTIONS.UNCLAIM') : t('ACTIONS.CLAIM');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    onClick();
  };

  return (
    <Tooltip label={label}>
      <ActionIcon
        size="sm"
        color="gray"
        variant="subtle"
        onClick={handleClick}
        aria-label={label}
      >
        <FontAwesomeIcon
          icon={isUnclaim ? faHandWave : faHand}
          size="sm"
          color="var(--mantine-color-text-4)"
        />
      </ActionIcon>
    </Tooltip>
  );
};
